import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const SingleUseBadge = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  padding: "4px 8px",

  borderRadius: "4px",
  background: colors.gray100,
  mixBlendMode: "multiply",

  color: colors.gray600,

  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
}));
